function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVercel = function SvgVercel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width,
    height: props.height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: props.viewBox
  }, props), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1 57.433 30 7l29 50.433H1ZM30 15.44 8.265 53.242h43.468L30 15.44Z",
    fill: props.color,
    stroke: props.color
  }));
};
export default SvgVercel;